exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".anchorButton__yVo3w.anchorButton__yVo3w {\n  line-height: 20px;\n  text-overflow: initial;\n  padding: 0;\n  height: 20px;\n}\n\n.anchorButton__yVo3w.anchorButton__yVo3w svg {\n  margin: 2px 6px 2px 0;\n}\n", ""]);

// Exports
exports.locals = {
	"anchorButton": "anchorButton__yVo3w"
};